import { csvToGeojsonConverter } from "./importParsers/csvToGeojsonConverter.js";
import { dxfToGeojsonConverter } from "./importParsers/dxfToGeojsonConverter.js";

/**
 * Main import converter: routes to the right <Type>ToGeojsonConverter and returns a unified shape.
 */
export async function importConverter({ file, importFormat }) {
  if (!file) return { geojson: null, errors: ["No file provided."] };

  const lower = String(file.name || "").toLowerCase();
  const isDxfOrDwg =
    importFormat === "dxf" ||
    lower.endsWith(".dxf") ||
    lower.endsWith(".dwg");

  if (isDxfOrDwg) {
    const out = await dxfToGeojsonConverter(file);
    return { ...out, format: "dxf" };
  }

  if (importFormat === "csv") {
    const out = await csvToGeojsonConverter(file);
    return { ...out, format: "csv" };
  }

  // Natural import for GeoJSON/JSON
  const text = await file.text();
  const geojson = JSON.parse(text);
  return { geojson, errors: [], format: "geojson" };
}

